import { getOrRefreshFirebaseToken } from "../../config/getFirebaseToken";
import addLogDocument from "../addLogDocument.js";
import { auth, dbCentral } from "../../config/FirebaseConfig.js";
import { getDoc, doc } from "firebase/firestore";

export const generateCarnetPdf = async (carnetId, prefix) => {
  const token = await getOrRefreshFirebaseToken();
  const url = `${prefix}carnets/${carnetId}/pdf_support`;

  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  try {
    const start = new Date();
    const response = await fetch(url, {
      method: "POST",
      headers,
    });

    const currentUser = auth.currentUser;

    if (!currentUser) {
      throw new Error("User not logged in");
    }

    const userRef = doc(dbCentral, "user", currentUser.uid);
    const userSnapshot = await getDoc(userRef);
    const responseText = await response.text();
    const end = new Date();
    const elapsed = end - start;

    if (userSnapshot.exists()) {
      const orgId = userSnapshot.get("org_id");

      await addLogDocument(
        url,
        prefix,
        userRef.id,
        orgId,
        response.status.toString(),
        "",
        carnetId,
        "",
        responseText,
        "POST",
        elapsed
      );
    }

    if (response.ok) {
      return JSON.parse(responseText);
    } else {
      console.error(`Failed to generate PDF: ${response.status}`);
      throw new Error(`Failed to generate PDF: ${response.status}`);
    }
  } catch (error) {
    console.error(`Exception occurred: ${error.message}`);
    throw error;
  }
};